import { ParagraphWithTooltip, paragraphSizes } from '@va/ui/design-system';
import classNames from 'classnames';
import { ReactNode } from 'react';

export const LegalDocumentsRowItem = ({
  icon,
  title,
  subTitle,
  className,
  rightSection,
}: {
  icon: ReactNode;
  title: string;
  subTitle?: string;
  className?: string;
  rightSection?: ReactNode;
}) => {
  return (
    <div className={classNames('flex h-72px bg-white-snow rounded-18px p-3 gap-15px items-center', className)}>
      {icon}
      <div className='flex flex-col truncate'>
        <ParagraphWithTooltip className='font-525!' colorClassName='text-gray-charcoal'>
          {title}
        </ParagraphWithTooltip>
        {subTitle && (
          <ParagraphWithTooltip size={paragraphSizes.tiny} className='font-525!' colorClassName='text-gray-devil'>
            {subTitle}
          </ParagraphWithTooltip>
        )}
      </div>
      <div className='flex ml-auto gap-3'>{rightSection}</div>
    </div>
  );
};
